import React from 'react';

import { ToggleButton, ToggleButtonGroup, ToggleButtonProps, Typography, styled, Theme, SxProps } from '@mui/material';

type ToggleButton = {
  label: string | React.ReactNode;
  value: string | number | boolean;
  state?: boolean | undefined;
  sx?: SxProps<Theme> | undefined;
  handleButtonClick?: () => void;
};

type ButtonProps = ToggleButtonProps & {
  buttons: ToggleButton[];
  handleClick: (state: boolean | undefined) => void;
};

const ButtonToggle = styled(ToggleButton)(({ theme }) => ({
  width: 88,
  height: 40,
  borderRadius: 32,
  '&.MuiToggleButton-root.Mui-selected': {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.bluViu.main,
    borderRadius: 32,
    border: 'none',
  },
  '&.MuiToggleButton-root': {
    backgroundColor: '#012231',
    color: theme.palette.common.white,
    borderRadius: 32,
  },
  '&:not(:last-of-type)': {
    marginRight: 2,
  },
}));

const ButtonGroup: React.FC<ButtonProps> = ({ buttons, handleClick, value, 'aria-label': ariaLabel }) => {
  const [selected, setSelected] = React.useState('left');

  const handleSelected = (event: React.MouseEvent<HTMLElement>, newSelection: string | null) => {
    if (newSelection !== null) {
      setSelected(newSelection);
    }
  };

  return (
    <ToggleButtonGroup
      value={selected}
      exclusive
      onChange={handleSelected}
      aria-label={ariaLabel}
      sx={{ borderRadius: 32, background: '#012231', border: 'solid #012231 4px', height: 'fit-content' }}>
      {buttons.length > 1 &&
        buttons.map((btn, idx) => (
          <ButtonToggle
            key={idx}
            sx={btn.sx}
            value={btn.value}
            onClick={() => {
              if (btn && btn.handleButtonClick) btn.handleButtonClick();
              handleClick(btn.state);
            }}>
            <Typography textTransform={'capitalize'} fontWeight={'500'}>
              {btn.label}
            </Typography>
          </ButtonToggle>
        ))}
    </ToggleButtonGroup>
  );
};

export default ButtonGroup;
